import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const Clock = ({ color = "#000", ...rest }: IconProps) => {
    return (
        <svg width="22" height="22" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path d="M4.53906 8C4.01377 8 3.49363 7.89654 3.00833 7.69552C2.52303 7.4945 2.08207 7.19986 1.71064 6.82843C1.3392 6.45699 1.04456 6.01604 0.843544 5.53073C0.642526 5.04543 0.539063 4.52529 0.539062 4C0.539062 3.47471 0.642526 2.95457 0.843544 2.46927C1.04456 1.98396 1.3392 1.54301 1.71064 1.17157C2.08207 0.800138 2.52303 0.505501 3.00833 0.304482C3.49363 0.103463 4.01377 -7.82739e-09 4.53906 0C5.59993 1.58081e-08 6.61734 0.421427 7.36749 1.17157C8.11763 1.92172 8.53906 2.93913 8.53906 4C8.53906 5.06087 8.11763 6.07828 7.36749 6.82843C6.61734 7.57857 5.59993 8 4.53906 8ZM4.98351 4V1.77778H4.09462V4.88889H6.31684V4H4.98351Z" fill={color} />
        </svg>

    )
}

export default Clock